import { Subscription } from '@innovyze/shared-utils';
import { InnovyzeRole } from '../utils/InnovyzeRole';

export interface License {
	reauthz: number;
	id: string;
	ceid: string;
	o2id: string;
	fid: string;
	exp: number;
	auth: boolean;
	iat: number;
	iss: string;
	lattr: number;
	lattrmsk: number;
}

export interface AutodeskContext {
	oxygenUserId: string;
	companyId: string; // teamId URN from Autodesk
	organizationId: string; // tenantId from Mongo
	projectId?: string;
	currentTeamLicenses: License[];
	otherTeamLicenses: License[];
	role: InnovyzeRole;
	inEmulation?: boolean;
	emulatorOxygenId?: string;
	name?: string;
	email?: string;
	subscriptions?: Record<string, string[]>;
	teamId: string;
	productAccessLevels: string[];
}

export interface Team {
	teamId: string;
	teamName: string;
	tenantId: string;
	projectId?: string;
	hubId?: string;
	projectSourceId?: string;
	entitlements?: Subscription[];
}

export interface AutodeskTeams {
	teams: Team[];
}

export interface AutodeskUserProfile {
	countryCode: string;
	createdDate: string;
	eidmGuid: string;
	emailId: string;
	emailVerified: boolean;
	firstName: string;
	language: string;
	lastLoginDate: string;
	lastModified: string;
	lastName: string;
	optin: boolean;
	profileImages: Record<string, string>;
	userId: string;
	userName: string;
}

export interface ForgeTokenResponse {
	token_type: string;
	expires_in: number;
	id_token: string;
	access_token: string;
	refresh_token: string;
}

export interface ForgeRefreshTokenResponse {
	token_type: string;
	expires_in: number;
	access_token: string;
	refresh_token: string;
}

export interface ForgeRefreshTokenResponseCamel {
	idToken: string;
	accessToken: string;
	refreshToken: string;
	expiresInSeconds: number;
}
